import { Fragment, useContext } from "react"
import styled from "styled-components";
import LoginForm from "../components/login/LoginForm";
import * as S from "../styles/layout/MainLayout.styled";
import { LogoSvg } from "../components/common/Icons";
import { CustomThemeContext } from "../App";

const BackGround = styled.div`
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;
    background: ${({theme}) => 
        theme.name === 'dark' 
            ? theme.color.primary_200 
            : theme.color.primary_100
    };
`;

const AuroraContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    opacity: ${({theme}) => theme.name === 'dark' ? 0.6 : 0.4};
    pointer-events: none;
`;

const AuroraPart = styled.div<{ $color: string; $duration: string; $delay: string; $top: string; $left: string }>`
    position: absolute;
    width: 150%;
    height: 150%;
    top: ${props => props.$top};
    left: ${props => props.$left};
    background: radial-gradient(circle at center, ${props => props.$color} 0%, transparent 70%);
    filter: blur(60px);
    opacity: 0.5;
    animation: move ${props => props.$duration} infinite alternate ease-in-out;
    animation-delay: ${props => props.$delay};

    @keyframes move {
        from {
            transform: translate(-10%, -10%) rotate(0deg);
        }
        to {
            transform: translate(10%, 10%) rotate(20deg);
        }
    }
`;

const ContentWrapper = styled.div`
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: center;
    margin-bottom: 12px;
`;

const TitleText = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
`;

const BrandName = styled.span`
    font-size: 42px;
    font-weight: 900;
    padding: 1px;
    background: linear-gradient(to top right, #4ECDEE 0%, #326BCC 35.0962%, #886FFD 65.8654%, #C7B4F5 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: 'Inter', sans-serif;
    letter-spacing: -2px;
    line-height: 1;
`;

const BrandSuffix = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.color.text_color_300};
    text-transform: uppercase;
    letter-spacing: 4px;
    margin-left: 4px;
    opacity: 0.8;
`;

const LinkTag = styled.a`
    color: ${({theme}) => theme.color.text_color_200};
    text-decoration: none;
    &:hover {
        text-decoration: underline;
    }
`;

const ThemeToggleWrapper = styled.div`
    position: absolute;
    top: 30px;
    right: 30px;
    z-index: 10;
`;

const ThemeToggle = styled.button`
    background: ${({ theme }) => theme.name === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.3)'};
    backdrop-filter: blur(10px);
    border: 1px solid ${({ theme }) => theme.name === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.5)'};
    border-radius: 12px;
    padding: 10px 18px;
    color: ${({ theme }) => theme.color.text_color_100};
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.2s;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

    &:hover {
        background-color: ${({ theme }) => theme.name === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.5)'};
        transform: translateY(-2px);
    }
`;

const LoginPage = () => {
    const { theme, onChangeTheme } = useContext(CustomThemeContext);

    return (
        <Fragment>
            <BackGround>
                <ThemeToggleWrapper>
                    <ThemeToggle onClick={onChangeTheme}>
                        {theme === 'light' ? '🌙 다크 모드' : '☀️ 라이트 모드'}
                    </ThemeToggle>
                </ThemeToggleWrapper>
                <AuroraContainer>
                    <AuroraPart $color="#3F63D8" $duration="15s" $delay="0s" $top="-50%" $left="-50%" />
                    <AuroraPart $color="#4F6FE5" $duration="20s" $delay="-5s" $top="-20%" $left="10%" />
                    <AuroraPart $color="#6F7787" $duration="18s" $delay="-10s" $top="20%" $left="-30%" />
                </AuroraContainer>
                <ContentWrapper>
                    <S.CenterLayout $width={600}>
                        <S.FlexV>
                            <S.AlignCenter>
                                <TitleWrapper>
                                    <LogoSvg size={64} />
                                    <TitleText>
                                        <BrandName>Callis</BrandName>
                                        <BrandSuffix>콘솔 시스템</BrandSuffix>
                                    </TitleText>
                                </TitleWrapper>
                            </S.AlignCenter>
                            <br/><br/>
                            <LoginForm/>
                            <br/><br/>
                            <S.AlignCenter>
                                <LinkTag rel="noreferrer" target="_blank" href="https://www.picksco.com">아직 계정이 없으신가요? <br/>[Callis 도입문의]</LinkTag>
                            </S.AlignCenter>
                        </S.FlexV>
                    </S.CenterLayout>
                </ContentWrapper>
            </BackGround>
        </Fragment>
    )
}

export default LoginPage;
